import { render, staticRenderFns } from "./related-tags-list.view.vue?vue&type=template&id=7c4f1c0d&scoped=true"
import script from "./related-tags-list.view.vue?vue&type=script&lang=ts"
export * from "./related-tags-list.view.vue?vue&type=script&lang=ts"
import style0 from "./related-tags-list.view.vue?vue&type=style&index=0&id=7c4f1c0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4f1c0d",
  null
  
)

export default component.exports